var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-grey-lightest" }, [
    _c(
      "section",
      { staticClass: "pt-12 pb-24", attrs: { id: "heading" } },
      [_c("header-nav", { ref: "headerNav" })],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "py-12" }, [
      _c("div", { staticClass: "max-w-sm mx-auto px-6" }, [
        _c("div", { staticClass: "rounded bg-white shadow relative -mt-24" }, [
          _vm.step == "patientForm"
            ? _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submitPatientForm($event)
                    }
                  }
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                      attrs: { to: { path: "/" } }
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-arrow-left" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "p-6 pt-12" }, [
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Firstname_")))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.patientForm.firstName,
                            expression: "patientForm.firstName"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass:
                          "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                        class: { "border-red": _vm.errors.has("first_name") },
                        attrs: { name: "first_name", type: "text" },
                        domProps: { value: _vm.patientForm.firstName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.patientForm,
                              "firstName",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("first_name"),
                              expression: "errors.has('first_name')"
                            }
                          ],
                          staticClass: "text-xs text-red font-semibold"
                        },
                        [_vm._v(_vm._s(_vm.$t("Please_fill_your_first_name")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Lastname_")))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.patientForm.lastName,
                            expression: "patientForm.lastName"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass:
                          "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                        class: { "border-red": _vm.errors.has("last_name") },
                        attrs: { name: "last_name", type: "text" },
                        domProps: { value: _vm.patientForm.lastName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.patientForm,
                              "lastName",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("last_name"),
                              expression: "errors.has('last_name')"
                            }
                          ],
                          staticClass: "text-xs text-red font-semibold"
                        },
                        [_vm._v(_vm._s(_vm.$t("Please_fill_your_last_name")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Age_")))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.patientForm.age,
                            expression: "patientForm.age"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|numeric",
                            expression: "'required|numeric'"
                          }
                        ],
                        staticClass:
                          "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                        class: {
                          "border-red": _vm.errors.has("patientForm.age")
                        },
                        attrs: {
                          name: "patientForm.age",
                          type: "number",
                          step: "1",
                          min: "0"
                        },
                        domProps: { value: _vm.patientForm.age },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.patientForm,
                              "age",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("patientForm.age"),
                              expression: "errors.has('patientForm.age')"
                            }
                          ],
                          staticClass: "text-xs text-red font-semibold"
                        },
                        [_vm._v(_vm._s(_vm.$t("Please_fill_your_age")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Medical_practice_")))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "relative" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.patientForm.type,
                                expression: "patientForm.type"
                              }
                            ],
                            staticClass:
                              "appearance-none bg-grey-lightest border pl-3 pr-8 py-2 text-grey-darker rounded w-full block outline-0",
                            attrs: { required: "" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.patientForm,
                                  "type",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { disabled: "" },
                                domProps: { value: null }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Select_a_medical_practice"))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.types, function(type) {
                              return _c(
                                "option",
                                { key: type, domProps: { value: type } },
                                [_vm._v(_vm._s(_vm.$t("type_" + type)))]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "pointer-events-none absolute pin-t pt-3 pin-r flex items-center px-2 text-grey-darker"
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "fill-current h-4 w-4",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 20 20"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d:
                                      "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mb-4" },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                          },
                          [_vm._v(_vm._s(_vm.$t("Locality_")))]
                        ),
                        _vm._v(" "),
                        _c("gmap-autocomplete", {
                          staticClass:
                            "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                          class: { "border-red": _vm.errors.has("locality") },
                          attrs: {
                            selectFirstOnEnter: true,
                            options: _vm.autocompleteOptions,
                            value: _vm.patientForm.locality,
                            placeholder: _vm.patientForm.locality
                              ? _vm.patientForm.locality
                              : _vm.$t("Enter_a_location"),
                            id: "search-form-field"
                          },
                          on: { place_changed: _vm.setPatientFormLocality }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("locality"),
                                expression: "errors.has('locality')"
                              }
                            ],
                            staticClass: "text-xs text-red font-semibold"
                          },
                          [_vm._v(_vm._s(_vm.$t("Please_fill_your_locality")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.patient || _vm.patient.email === null
                      ? _c("div", { staticClass: "mb-4" }, [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                            },
                            [_vm._v(_vm._s(_vm.$t("Email_address_")))]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.patientForm.email,
                                expression: "patientForm.email"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|email",
                                expression: "'required|email'"
                              }
                            ],
                            staticClass:
                              "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                            class: { "border-red": _vm.errors.has("email") },
                            attrs: { name: "email", type: "email" },
                            domProps: { value: _vm.patientForm.email },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.patientForm,
                                  "email",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("email"),
                                  expression: "errors.has('email')"
                                }
                              ],
                              staticClass: "text-xs text-red font-semibold"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Please_fill_your_email_address"))
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Phone_number_")))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.patientForm.phone,
                            expression: "patientForm.phone"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|phone:BE",
                            expression: "'required|phone:BE'"
                          }
                        ],
                        staticClass:
                          "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                        class: { "border-red": _vm.errors.has("phone") },
                        attrs: { name: "phone", type: "phone" },
                        domProps: { value: _vm.patientForm.phone },
                        on: {
                          blur: _vm.transformPhone,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.patientForm,
                              "phone",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("phone"),
                              expression: "errors.has('phone')"
                            }
                          ],
                          staticClass: "text-xs text-red font-semibold"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Please_fill_your_phone_number"))
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                        attrs: { type: "submit" }
                      },
                      [_vm._v(_vm._s(_vm.$t("Next")))]
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.step == "patientSymptoms"
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass:
                      "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.changeStep("patientForm")
                      }
                    }
                  },
                  [_vm._m(0)]
                ),
                _vm._v(" "),
                _vm.sections.length > 0
                  ? _c(
                      "div",
                      { staticClass: "px-6 pt-12 pb-4" },
                      _vm._l(_vm.sections, function(section, sectionIndex) {
                        return _c(
                          "form",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: sectionIndex === _vm.currentSection,
                                expression: "sectionIndex === currentSection"
                              }
                            ],
                            key: "section-" + sectionIndex,
                            staticClass: "mb-4",
                            attrs: {
                              "data-vv-scope": "section-" + sectionIndex
                            },
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.nextSection($event)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "mb-4 text-lg font-semibold" },
                              [_vm._v(_vm._s(section.title))]
                            ),
                            _vm._v(" "),
                            section.description
                              ? _c("div", {
                                  staticClass: "text-sm text-grey-dark mb-4",
                                  domProps: {
                                    innerHTML: _vm._s(section.description)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(section.questions, function(
                              question,
                              questionIndex
                            ) {
                              return !Object.keys(question).includes(
                                "conditions"
                              ) || _vm.conditionsMatches(question, section)
                                ? _c(
                                    "div",
                                    {
                                      key: "question-" + questionIndex,
                                      staticClass: "mb-4"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-blue text-sm font-semibold mb-4"
                                        },
                                        [_vm._v(_vm._s(question.label))]
                                      ),
                                      _vm._v(" "),
                                      question.type === "checkboxes"
                                        ? [
                                            _vm._l(question.choices, function(
                                              choice,
                                              choiceIndex
                                            ) {
                                              return _c(
                                                "label",
                                                {
                                                  key: "choice-" + choiceIndex,
                                                  staticClass:
                                                    "relative flex items-center text-sm text-grey-dark group-hover:text-grey-darkest mb-2"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      type: "checkbox",
                                                      name:
                                                        "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    },
                                                    domProps: {
                                                      value: choice,
                                                      checked:
                                                        question.value.length &&
                                                        question.value.includes(
                                                          choice
                                                        )
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.toggleSymptom(
                                                          question,
                                                          choice
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(_vm._s(choice))
                                                  ])
                                                ]
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    ),
                                                    expression:
                                                      "errors.has(`section.${sectionIndex}.${questionIndex}`)"
                                                  }
                                                ],
                                                staticClass:
                                                  "text-xs text-red font-semibold"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Please_specify")
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      question.type === "select"
                                        ? [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: question.value,
                                                    expression: "question.value"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                staticClass:
                                                  "appearance-none bg-grey-lightest border pl-3 pr-8 py-2 text-grey-darker rounded w-full block outline-0",
                                                attrs: {
                                                  name:
                                                    "section." +
                                                    sectionIndex +
                                                    "." +
                                                    questionIndex
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$selectedVal = Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function(o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function(o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                    _vm.$set(
                                                      question,
                                                      "value",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  { domProps: { value: null } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Select_an_option"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  question.choices,
                                                  function(
                                                    choice,
                                                    choiceIndex
                                                  ) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key:
                                                          "choice-" +
                                                          choiceIndex,
                                                        domProps: {
                                                          value: choice
                                                        }
                                                      },
                                                      [_vm._v(_vm._s(choice))]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    ),
                                                    expression:
                                                      "errors.has(`section.${sectionIndex}.${questionIndex}`)"
                                                  }
                                                ],
                                                staticClass:
                                                  "text-xs text-red font-semibold"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Please_specify")
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      question.type === "radio"
                                        ? [
                                            _vm._l(question.choices, function(
                                              choice,
                                              choiceIndex
                                            ) {
                                              return _c(
                                                "label",
                                                {
                                                  key: "choice-" + choiceIndex,
                                                  staticClass:
                                                    "relative flex items-center text-sm text-grey-dark group-hover:text-grey-darkest mb-3"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: question.value,
                                                        expression:
                                                          "question.value"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      type: "radio",
                                                      name:
                                                        "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    },
                                                    domProps: {
                                                      value: choice,
                                                      checked: _vm._q(
                                                        question.value,
                                                        choice
                                                      )
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.$set(
                                                          question,
                                                          "value",
                                                          choice
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(_vm._s(choice))
                                                  ])
                                                ]
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    ),
                                                    expression:
                                                      "errors.has(`section.${sectionIndex}.${questionIndex}`)"
                                                  }
                                                ],
                                                staticClass:
                                                  "text-xs text-red font-semibold"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Please_specify")
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      question.type === "boolean"
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex flex-wrap -mx-4"
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "block group mb-2 px-4"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: question.value,
                                                          expression:
                                                            "question.value"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        type: "radio",
                                                        name:
                                                          "section." +
                                                          sectionIndex +
                                                          "." +
                                                          questionIndex
                                                      },
                                                      domProps: {
                                                        value: true,
                                                        checked: _vm._q(
                                                          question.value,
                                                          true
                                                        )
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            question,
                                                            "value",
                                                            true
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-sm text-grey-dark group-hover:text-grey-darkest"
                                                      },
                                                      [_vm._v("Yes")]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "block group mb-2 px-4"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: question.value,
                                                          expression:
                                                            "question.value"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        type: "radio",
                                                        name:
                                                          "section." +
                                                          sectionIndex +
                                                          "." +
                                                          questionIndex
                                                      },
                                                      domProps: {
                                                        value: false,
                                                        checked: _vm._q(
                                                          question.value,
                                                          false
                                                        )
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            question,
                                                            "value",
                                                            false
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-sm text-grey-dark group-hover:text-grey-darkest"
                                                      },
                                                      [_vm._v("No")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    ),
                                                    expression:
                                                      "errors.has(`section.${sectionIndex}.${questionIndex}`)"
                                                  }
                                                ],
                                                staticClass:
                                                  "text-xs text-red font-semibold"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Please_specify")
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      question.type === "textarea"
                                        ? [
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: question.value,
                                                  expression: "question.value"
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              staticClass:
                                                "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                                              attrs: {
                                                rows: "5",
                                                name:
                                                  "section." +
                                                  sectionIndex +
                                                  "." +
                                                  questionIndex
                                              },
                                              domProps: {
                                                value: question.value
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    question,
                                                    "value",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    ),
                                                    expression:
                                                      "errors.has(`section.${sectionIndex}.${questionIndex}`)"
                                                  }
                                                ],
                                                staticClass:
                                                  "text-xs text-red font-semibold"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Please_specify")
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                attrs: { type: "button" },
                                on: { click: _vm.nextSection }
                              },
                              [_vm._v(_vm._s(_vm.$t("Next")))]
                            ),
                            _vm._v(" "),
                            _vm.currentSection > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "bg-transparent hover:underline text-sm text-grey-darker w-full px-4 py-3 mt-2",
                                    attrs: { type: "button" },
                                    on: { click: _vm.previousSection }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Go_back")))]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.step == "submissionSummary"
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass:
                      "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                    on: {
                      click: function($event) {
                        return _vm.changeStep("patientSymptoms")
                      }
                    }
                  },
                  [_vm._m(1)]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "px-6 py-4" }, [
                  _c(
                    "h4",
                    {
                      staticClass:
                        "text-xl uppercase tracking-wide text-grey-darkest"
                    },
                    [_vm._v(_vm._s(_vm.$t("Summary")))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "p-6 pt-4" },
                  [
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Name")))]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "block w-full text-grey-darker",
                        domProps: {
                          textContent: _vm._s(
                            _vm.patientForm.firstName +
                              " " +
                              _vm.patientForm.lastName
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Age")))]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "block w-full text-grey-darker",
                        domProps: { textContent: _vm._s(_vm.patientForm.age) }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Locality")))]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "block w-full text-grey-darker",
                        domProps: {
                          textContent: _vm._s(_vm.patientForm.locality)
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Email_address")))]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "block w-full text-grey-darker",
                        domProps: { textContent: _vm._s(_vm.patientForm.email) }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Phone_number")))]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "block w-full text-grey-darker",
                        domProps: { textContent: _vm._s(_vm.patientForm.phone) }
                      })
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.sections, function(section, sectionIndex) {
                      return _c(
                        "div",
                        { key: sectionIndex },
                        [
                          _c(
                            "div",
                            { staticClass: "mb-4 text-lg font-semibold" },
                            [_vm._v(_vm._s(section.title))]
                          ),
                          _vm._v(" "),
                          _vm._l(section.questions, function(
                            question,
                            questionIndex
                          ) {
                            return _c(
                              "div",
                              {
                                key: "question-" + questionIndex,
                                staticClass: "mb-4"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                                  },
                                  [_vm._v(_vm._s(question.label))]
                                ),
                                _vm._v(" "),
                                typeof question.value === "boolean"
                                  ? [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "block w-full text-grey-darker"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              question.value ? "Yes" : "No"
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  : Array.isArray(question.value)
                                  ? [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "block w-full text-grey-darker"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(question.value.join(", "))
                                          )
                                        ]
                                      )
                                    ]
                                  : [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "block w-full text-grey-darker"
                                        },
                                        [_vm._v(_vm._s(question.value))]
                                      )
                                    ]
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "relative" },
                      [
                        _c("bubble", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "I_will_inform_you_as_soon_as_a_timeslot_is_available"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3 mt-6",
                            on: { click: _vm.confirmReservation }
                          },
                          [_vm._v(_vm._s(_vm.$t("Confirm")))]
                        )
                      ],
                      1
                    )
                  ],
                  2
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.step == "submitting"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "flex items-center justify-center h-64" },
                  [
                    _c("div", { staticClass: "text-center" }, [
                      _vm._m(2),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "text-sm text-grey-darker mt-4" },
                        [_vm._v(_vm._s(_vm.$t("Loading")))]
                      )
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.step == "submitted"
            ? _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "text-green-lighter hover:text-green-lightest text-xl absolute pin-t pin-r p-2 m-2",
                      attrs: { to: { path: "/" } }
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-close" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center bg-green text-white rounded px-4 py-10 w-full"
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-sm text-xl ml-4" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "As_soon_as_a_appointment_is_available_Tood_will_inform_you"
                            )
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.step == "submissionError"
            ? _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "text-red-lighter hover:text-red-lightest text-xl absolute pin-t pin-r p-2 m-2",
                      attrs: { to: { path: "/" } }
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-close" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center bg-red text-white rounded px-4 py-10 w-full"
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "text-sm text-xl ml-4",
                        domProps: {
                          textContent: _vm._s(
                            _vm.errorText
                              ? _vm.errorText
                              : _vm.$t("an_error_occured")
                          )
                        }
                      })
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.step == "submitted"
          ? _c(
              "div",
              { staticClass: "mt-3 text-sm text-center text-grey-dark" },
              [_vm._v(_vm._s(_vm.$t("Redirecting")))]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-arrow-left" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-arrow-left" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-grey" }, [
      _c("i", { staticClass: "mdi mdi-loading mdi-spin" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-white" }, [
      _c("i", { staticClass: "mdi mdi-verified" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-white" }, [
      _c("i", { staticClass: "mdi mdi-alert-circle" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56fbd8e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56fbd8e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/EmergencyNew.vue
// module id = 765
// module chunks = 1